export default __webpack_public_path__ + "static/media/BOP_PandleFirstBank_white_logo.f9237dcb.png";